<template>
  <v-content>
    <v-toolbar class="bg-color-error" dark extended flat>
      <v-btn dark icon @click="goHome()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">Oops</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm7>
                  <v-card-title class="pb-0">
                    <div>
                      <h3 class="headline mb-0">Oops. We encountered an unexpected error.</h3>
                      <span class="grey--text" style="word-wrap: anywhere; line-height: 36px;">
                        {{code}}
                      </span>
                      <p style="word-wrap: anywhere; line-height: 36px;">
                        You can copy above text and email it to development@edvant.net
                      </p>
                    </div>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 sm5 class="hidden-xs-only pt-2">
                  <v-img contain class="ma-3" src="/assets/error.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 d-flex justify-center>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
        code: this.$route.params.code,
      };
    },
    methods: {
      goHome() {
        window.history.back();
      },
    }
  };
</script>
